import PropTypes from 'prop-types'
import React from 'react'
import { AdBreadcrumbs } from 'SRC/modules/ads/shared/components/AdBreadcrumbs'

export const Header = () => <AdBreadcrumbs isAdDetail />
